var _defs, _polyline, _ellipse, _path, _polygon, _polyline2, _ellipse2, _path2, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _line, _line2, _polygon11, _line3, _line4, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _path3, _polygon29, _polygon30, _polygon31, _path4, _ellipse3, _polygon32, _polygon33, _path5, _path6, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _path7, _ellipse4, _path8, _ellipse5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 569.93 502.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#407bd3;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#033580;}.cls-3{fill:#bbdcfc;}.cls-4{fill:#fff;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "153.91 59.63 152.66 83.45 146.41 202.75 193.61 202.75 187.37 83.68 186.11 59.63"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 170.01,
    cy: 59.63,
    rx: 16.1,
    ry: 8.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.5,393.72c-23.51,5.9-34.71-.23-34.71-.23l-.8,15.22s13.21,7.28,36.3,0Z",
    transform: "translate(-164.13 -310.04)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "440.51 34.65 423.15 42.95 423.15 451.93 440.51 437.15 440.51 34.65"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "105.06 42.76 103.81 66.58 97.55 185.88 144.76 185.88 138.52 66.81 137.26 42.76"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 121.16,
    cy: 42.76,
    rx: 16.1,
    ry: 8.31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.65,376.85c-23.51,5.9-34.71-.23-34.71-.23l-.8,15.22s13.21,7.27,36.3,0Z",
    transform: "translate(-164.13 -310.04)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.45 465.54 0.5 415.01 0.5 236.06 179.45 286.59 179.45 465.54"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "257.34 168.7 78.39 118.17 0.5 236.06 179.45 286.59 257.34 168.7"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "94.67 227.28 62.41 218.17 62.41 185.91 94.67 195.02 94.67 227.28"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "94.67 195.11 62.41 186 81.04 170.9 113.31 180.01 94.67 195.11"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.31 180.01 94.67 227.28 94.67 195.11 113.31 180.01"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "150.28 243.8 118.02 234.69 118.02 202.42 150.28 211.53 150.28 243.8"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "150.28 211.63 118.02 202.52 136.65 187.42 168.92 196.53 150.28 211.63"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.92 196.53 150.28 243.8 150.28 211.63 168.92 196.53"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "90.88 222.42 66.2 215.45 66.2 190.77 90.88 197.74 90.88 222.42"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 76.82,
    y1: 218.45,
    x2: 77.89,
    y2: 194.26
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 66.2,
    y1: 203.65,
    x2: 90.88,
    y2: 210.42
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "146.49 239.25 121.81 232.28 121.81 207.59 146.49 214.56 146.49 239.25"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.42,
    y1: 235.52,
    x2: 133.5,
    y2: 211.33
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 121.81,
    y1: 220.71,
    x2: 146.49,
    y2: 227.48
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "295.24 122.38 179.45 92.91 179.45 465.54 295.24 495.01 295.24 122.38"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "458.39 52.91 342.61 23.43 179.45 92.91 295.24 122.38 458.39 52.91"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "458.39 53.96 295.24 122.38 295.24 495.01 458.39 426.59 458.39 53.96"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "247.07 87.83 198.72 74.41 198.72 483.38 247.07 496.8 247.07 87.83"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "440.47 13.92 392.12 0.5 198.68 75.02 247.03 88.44 440.47 13.92"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "257.34 85.34 246.87 88.44 246.87 497.41 257.34 487.84 257.34 85.34"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "440.31 35.65 440.51 14.35 247.07 88.87 246.87 110.17 440.31 35.65"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "198.44 97.73 179.45 92.91 179.73 154.48 198.72 158.81 198.44 97.73"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "198.72 158.07 179.73 153.25 179.73 213.26 198.72 217.59 198.72 158.07"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "198.72 216.81 179.73 211.99 179.73 272 198.72 276.33 198.72 216.81"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "198.72 275.93 179.73 271.11 179.73 331.12 198.72 335.45 198.72 275.93"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "198.72 335.19 179.73 330.36 179.73 390.38 198.72 394.71 198.72 335.19"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "198.68 393.78 179.73 388.96 179.73 467.59 198.68 471.92 198.68 393.78"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "496.29 382.85 350.01 352.8 350.01 471.84 496.29 501.88 496.29 382.85"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "569.43 352.8 423.15 322.76 350.01 351.98 496.29 382.02 569.43 352.8"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "569.43 352.8 496.29 382.02 496.29 501.06 569.43 471.84 569.43 352.8"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "453.31 438.55 386.99 424.93 386.99 478.89 453.31 492.51 453.31 438.55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M605.09,699.44l-32.68-6.05a8.08,8.08,0,0,0-9.53,8.54h0a8.09,8.09,0,0,0,6.59,7.36l32.68,6a8.08,8.08,0,0,0,9.53-8.54h0A8.08,8.08,0,0,0,605.09,699.44Z",
    transform: "translate(-164.13 -310.04)"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "487 360.28 459.72 353.88 459.72 360.28 487 366.68 487 360.28"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "506.05 353.88 478.77 347.48 459.72 353.88 487 360.28 506.05 353.88"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "506.05 353.88 487 360.28 487 366.68 506.05 360.28 506.05 353.88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M641.6,651.87,640,663.3s7.56,3.43,12.72.17L651.49,652",
    transform: "translate(-164.13 -310.04)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 646.55,
    cy: 651.93,
    rx: 3.43,
    ry: 4.95,
    transform: "translate(-178.33 979.43) rotate(-89.21)"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "527.62 444.79 510.92 451.46 510.92 478.64 527.62 471.97 527.62 444.79"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "555.9 435 539.2 441.68 539.2 468.86 555.9 462.18 555.9 435"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M558.4,659.06s4.93-32-15-29.26c0,0-5.41,6.28,0,9.67,5.95,3.72,3.31,17,3.31,17S549.55,661,558.4,659.06Z",
    transform: "translate(-164.13 -310.04)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M575.2,653.81s4.93-32-15.05-29.26c0,0-5.41,6.28,0,9.67,6,3.71,3.31,17,3.31,17S566.34,655.71,575.2,653.81Z",
    transform: "translate(-164.13 -310.04)"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "295.24 122.38 257.34 112.73 257.34 172.75 295.24 181.9 295.24 122.38"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "295.24 181.17 257.34 171.52 257.34 231.53 295.24 240.69 295.24 181.17"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "295.24 239.91 257.34 230.26 257.34 290.27 295.24 299.43 295.24 239.91"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "295.24 299.02 257.34 289.38 257.34 349.39 295.24 358.54 295.24 299.02"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "295.24 358.28 257.34 348.63 257.34 408.64 295.24 417.8 295.24 358.28"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "295.24 416.88 257.34 407.23 257.34 485.86 295.24 495.01 295.24 416.88"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.53 317.6 15.92 306.98 15.92 269.37 53.53 279.99 53.53 317.6"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "91.14 328.72 53.53 318.1 53.53 280.49 91.14 291.11 91.14 328.72"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.75 339.33 91.14 328.71 91.14 291.11 128.75 301.73 128.75 339.33"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.36 350.45 128.75 339.83 128.75 302.22 166.36 312.84 166.36 350.45"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.53 353.87 15.92 343.25 15.92 305.64 53.53 316.26 53.53 353.87"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "91.14 364.99 53.53 354.37 53.53 316.76 91.14 327.38 91.14 364.99"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.75 375.6 91.14 364.98 91.14 327.37 128.75 337.99 128.75 375.6"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.36 386.72 128.75 376.1 128.75 338.49 166.36 349.11 166.36 386.72"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.53 391.48 15.92 380.86 15.92 343.25 53.53 353.87 53.53 391.48"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "91.14 402.6 53.53 391.98 53.53 354.37 91.14 364.99 91.14 402.6"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.75 413.21 91.14 402.6 91.14 364.99 128.75 375.61 128.75 413.21"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.36 424.33 128.75 413.71 128.75 376.1 166.36 386.72 166.36 424.33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.27,474.63,252,499s4,2.84,8.05,0l-1.28-24.4",
    transform: "translate(-164.13 -310.04)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 91.88,
    cy: 164.59,
    rx: 2.75,
    ry: 1.42
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M308.88,491.47l-1.28,24.4s4,2.84,8,0l-1.28-24.4",
    transform: "translate(-164.13 -310.04)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 147.49,
    cy: 181.43,
    rx: 2.75,
    ry: 1.42
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.e48ac89277f42832f3da7b8731638c51.svg";
export { ForwardRef as ReactComponent };